<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('contact') }}</h2>

      <h3 class="mb20">{{ $t('thank_you_for_your_contact') }}</h3>

      <p class="mb30" v-html="$t('thank_you_for_your_contact_we_will_check_the_contents')">
      </p>

      <p class="mb50" v-html="$t('if_you_do_not_receive_a_call_back_from_us_within_3_business_days')">
      </p>

      <div class="btn-base" @click="onFinished()">
        <a href="javascript:;">
          <p>{{ $t('back') }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.screenTracking(this.$t('contact_transmission_completed'))
  },
  methods: {
    onFinished() {
      this.$router.push({ path: '/' }).catch(err => {})
    }
  }
};
</script>
